import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Supabase } from './supabase';

/**
 * Allow the route when a session exists. getSession() restores from localStorage
 * and, if the access token is stale, silently refreshes it — so a reload never
 * bounces a signed-in user to /login. Only a genuinely absent session redirects.
 */
export const authGuard: CanActivateFn = async () => {
  const supabase = inject(Supabase);
  const router = inject(Router);
  try {
    const session = await supabase.getSession();
    if (session) return true;
  } catch {
    // fall through to redirect
  }
  return router.parseUrl('/login');
};
